import { useTranslations } from "next-intl";
import Image from "next/image";
import { useEffect, useState } from "react";
import { absorptionsData } from "src/config/absorptionsData";
import classNames from "src/helpers/classNames";
import getAbsorptionData from "src/helpers/getAbsorptionData";

interface AbsorptionExplanationProps {
  selectedAbsorption: string | null;
}

const AbsorptionExplanation = ({
  selectedAbsorption,
}: AbsorptionExplanationProps) => {
  const t = useTranslations("ProductOverview");

  const [absorptionData, setAbsorptionData] =
    useState<absorptionsData | null>();

  useEffect(() => {
    setAbsorptionData(getAbsorptionData(selectedAbsorption));
  }, [selectedAbsorption]);

  if (absorptionData)
    return (
      <>
        <p className="py-2.5">{t(absorptionData.title)}</p>
        <section className="flex justify-around gap-6 py-4">
          <div className="flex flex-1 flex-col items-center gap-4">
            <Image
              src={`/images/product-page/absorption-select/${absorptionData.layersImage}`}
              alt="Layers"
              className="my-auto w-auto"
              sizes="14rem"
              width={0}
              height={0}
              priority
            />
            <p className="mt-auto text-sm text-gray-400 sm:text-base">
              {t(absorptionData.layersText)}
            </p>
          </div>
          <span className="my-auto text-3xl ">=</span>
          <div className="flex flex-1 flex-col items-center gap-4">
            <div
              className={classNames(
                "mt-auto flex flex-wrap justify-center",
                absorptionData.pads % 2 === 0
                  ? "w-20 sm:w-28"
                  : "w-[7.5rem] sm:w-[10.5rem]"
              )}
            >
              {[...Array(absorptionData.pads)].map(
                (icon: any, index: number) => (
                  <Image
                    key={index}
                    src="/images/product-page/absorption-select/pads-icon.png"
                    alt="Pad icon"
                    className="w-10 p-1 sm:w-14 sm:p-2"
                    sizes="4rem"
                    width={0}
                    height={0}
                  />
                )
              )}
            </div>
            <p className="mt-auto text-sm text-gray-400 sm:text-base">
              {t(absorptionData.padsText, {
                numberOfPads: absorptionData.pads,
              })}
            </p>
          </div>
        </section>
      </>
    );
  else return <></>;
};

export default AbsorptionExplanation;
